<template>
  <div
    v-if="company && $login.can('companies.view')"
    class="companies-view"
  >
    <page-header :header="company ? company.name : 'Company'" />
    <tabs>
      <tab name="Details">
        <read-only
          :company="company"
          :can-edit="canEdit"
        />
      </tab>
      <tab name="Recommendation">
        <recommendation
          :company="company"
        />
      </tab>
      <tab
        v-if="false"
        name="Models"
      >
        <models
          :company="company"
        />
      </tab>
      <tab
        v-if="company.new_company"
        name="Securities"
      >
        <securities
          :company="company"
        />
      </tab>
    </tabs>
  </div>
</template>

<script>
import axios from '@/axios'

import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
// import Analytics from './Analytics'
import Recommendation from './Recommendation'
import ReadOnly from './ReadOnly'
import Securities from './Securities'
import Models from './Models'
import {successNotification} from '@/notifications'

export default {
  components: {
    Tabs,
    Tab,
    ReadOnly,
    Securities,
    Recommendation,
    Models,
  },

  metaInfo () {
    return {
      title: this.company ? this.company.name : 'View Company',
    }
  },

  data () {
    return {
      company: null,
      loading: false,
      tickerShowRemove: [],
    }
  },

  created () {
    const {companyId} = this.$route.params
    this.getCompany(companyId)
  },

  computed: {
    canEdit () {
      return this.$login.can('companies.update')
    },
  },

  methods: {
    async getCompany (id) {
      const {data} = await axios.get('/companies/' + id)
      this.company = data.data
    },

    setLoading (loading) {
      this.loading = loading
    },

    saveSuccess (response) {
      this.$notify(successNotification('Saved company successfully'))
      this.$router.push({name: 'companies'})
    },
  },
}
</script>
